const mediaItems = [
  {
    title: '《长风渡》收官回顾：一部让人上头的古装甜宠剧',
    desc: '从开播到大结局，《长风渡》以精良的制作、出色的演技和甜而不腻的剧情赢得了观众的一致好评。本片回顾带你重温剧中那些让人心动的名场面。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20a%20traditional%20Chinese%20ancient%20costume%20drama%20with%20elegant%20couple%20in%20flowing%20silk%20robes%20standing%20in%20a%20moonlit%20garden%20with%20cherry%20blossoms%2C%20soft%20romantic%20lighting%2C%20warm%20golden%20lantern%20glow%2C%20dreamy%20atmospheric%20mood%2C%20widescreen%20cinematic%20composition&width=640&height=360&seq=media-drama-01&orientation=landscape',
    duration: '04:28',
    views: '12.8万',
  },
  {
    title: '悬疑剧安利：《漫长的季节》为何被封为年度神作',
    desc: '豆瓣9.4分的国产悬疑天花板，从剧本到表演到摄影都堪称完美。一场跨越二十年的谜案，三条时间线交织推进，每个细节都是精心设计的伏笔。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20moody%20scene%20of%20a%20northern%20Chinese%20industrial%20town%20in%20autumn%2C%20rusty%20railway%20tracks%2C%20golden%20fallen%20leaves%2C%20overcast%20sky%20with%20soft%20diffused%20light%2C%20nostalgic%20melancholic%20atmosphere%2C%20film%20grain%20texture%2C%20warm%20amber%20and%20teal%20color%20grading&width=640&height=360&seq=media-drama-02&orientation=landscape',
    duration: '06:15',
    views: '28.3万',
  },
  {
    title: '韩剧《黑暗荣耀》深度解析：复仇的代价是什么',
    desc: '宋慧乔主演的复仇爽剧《黑暗荣耀》引发全网热议，从校园暴力到成人复仇，这部剧不只是爽，更深刻探讨了正义、宽恕与人性的复杂。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20scene%20with%20a%20woman%20in%20dark%20elegant%20clothing%20standing%20by%20a%20large%20window%20overlooking%20a%20city%20at%20twilight%2C%20cold%20blue%20and%20warm%20interior%20light%20contrast%2C%20determined%20expression%2C%20minimalist%20modern%20interior%2C%20film%20noir%20aesthetic%2C%20strong%20visual%20storytelling&width=640&height=360&seq=media-drama-03&orientation=landscape',
    duration: '05:42',
    views: '19.6万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          热播推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          编辑精选热播好剧，每一部都值得花时间追
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, index) => (
            <div
              key={index}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200 transition-all duration-300 hover:shadow-md cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center bg-background-50/90 rounded-full group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl text-primary-500"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">{item.desc}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}次观看
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}